import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { listAllBuildEmployer } from "../../actions/employerAction";
import { listBuildApplyDev } from "../../actions/developerAction";
import DevWelcome from "../../components/DevWelcome";
import DevMenu from "../../components/DevMenu";
import RightDash from "../../components/RightDash";
import Message from "../../components/Message";
import Login from "../Login";
import { truncateString } from "../../helpers";
import Signout from "../../components/Signout";
import "../../styles/dashboard.css";

const DeveloperDashJob = ({ history, resizeMenu, setResizeMenu }) => {
  const dispatch = useDispatch();

  const userLogin = useSelector((state) => state.userLogin);

  const { userInfo } = userLogin;

  const listAllBuild = useSelector((state) => state.listAllBuild);

  const { jobs, loading, error } = listAllBuild;

  useEffect(() => {
    dispatch(listAllBuildEmployer());
  }, [listAllBuildEmployer]);

  if (!userInfo) {
    return <Login />;
  }

  if (userInfo && userInfo.role === "employer") {
    history.push("/employer/dashboard");
  }

  return (
    <div className="dashboard">
      <DevMenu resizeMenu={resizeMenu} setResizeMenu={setResizeMenu} />
      <RightDash resizeMenu={resizeMenu} setResizeMenu={setResizeMenu}>
        {loading ? (
          <div className="d-flex justify-content-center align-items-center w-100 h-100">
            <div className="spinner-blue"></div>
          </div>
        ) : error ? (
          <Message variant="danger">
            {error} <a href="/developer/jobs">refresh page</a>
          </Message>
        ) : (
          <div className="right-wrapper">
            <DevWelcome />
            <div className="main p-3">
              <h4 className="font-medium mb-2">Jobs</h4>
              <div className="row">
                {jobs.length === 0 && <div>No job application yet</div>}
                {jobs &&
                  jobs.filter((job) => job.status === "progress").length ===
                    0 && <div>Job Applications are being processed</div>}
                {jobs &&
                  jobs
                    .filter((job) => job.status === "progress")
                    .map((job) => (
                      <div
                        className="col-md-5 mb-2"
                        key={job._id}
                        style={{ minWidth: "300px" }}>
                        <Link
                          to={`/developer/dashboard/job/${job._id}`}
                          className="details px-1 py-1 rounded shadow-sm d-inline-block w-100">
                          <div className="font-normal">
                            <h5 className="lh-small mb-1 font-normal">
                              {job.title}
                            </h5>
                            <p
                              className="text-black-fade break m-0"
                              style={{ fontSize: "12px" }}>
                              Budget: ${job.budget}{" "}
                              <span className="font-weight-bolder ml-25">
                                {job.createdAt && job.createdAt.slice(0, 10)}
                              </span>
                            </p>
                            <p className="font-sm text-black break">
                              {truncateString(job.details, 40)}
                            </p>
                          </div>
                          <div className="skills">
                            {job.skill.map((skill, i) => (
                              <button key={i}>{skill}</button>
                            ))}
                          </div>
                        </Link>
                      </div>
                    ))}
              </div>
            </div>
          </div>
        )}
      </RightDash>
    </div>
  );
};

export default DeveloperDashJob;
